import { useState } from "react";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

const message = (nom, annee) => `Bonjour${nom ? ` ${nom}` : ""},\n\nVous trouverez ci-joint la conciliation TPS/TVQ ${annee} : bilan par trimestre et de l'année, suivi du trop-payé, acomptes et comparaison avec l'état de compte de Revenu Québec.\n\nMerci et bonne journée`;

// Envoi du PDF de la conciliation au comptable, après vérification de l'adresse et du message
export const EnvoiConciliation = ({ annee }) => {
  const [ouvert, setOuvert] = useState(false);
  const [f, setF] = useState({ email: "", message: "" });
  const [envoi, setEnvoi] = useState(false);
  const ouvrir = async () => {
    setOuvert(true);
    try { const { data } = await api.get("/comptable"); setF({ email: data.email, message: message(data.nom, annee) }); } catch { setF({ email: "", message: message("", annee) }); }
  };
  const envoyer = async () => {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.email.trim())) { toast.error("Adresse courriel invalide"); return; }
    setEnvoi(true);
    try {
      const { data } = await api.post("/conciliation-taxes/envoyer", { annee: Number(annee), ...f, email: f.email.trim() });
      toast.success(`Conciliation envoyée à ${data.destinataire}${data.copie ? " (copie reçue)" : ""}`);
      setOuvert(false);
    } catch (e) { toast.error(errMsg(e)); } finally { setEnvoi(false); }
  };
  return (
    <>
      <Button size="sm" variant="outline" onClick={ouvrir} data-testid="conciliation-envoyer"><Send className="h-3.5 w-3.5 mr-1" />Au comptable</Button>
      <Dialog open={ouvert} onOpenChange={setOuvert}>
        <DialogContent data-testid="conciliation-envoi-dialog">
          <DialogHeader>
            <DialogTitle>Envoyer la conciliation TPS/TVQ {annee}</DialogTitle>
            <DialogDescription>Un vrai courriel part avec le PDF « Conciliation TPS-TVQ {annee}.pdf », et une copie à votre adresse.</DialogDescription>
          </DialogHeader>
          <div className="space-y-3">
            <Input type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} placeholder="adresse du comptable" data-testid="conciliation-envoi-email" />
            <Textarea rows={7} value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} data-testid="conciliation-envoi-message" />
          </div>
          <DialogFooter>
            <Button variant="ghost" onClick={() => setOuvert(false)} data-testid="conciliation-envoi-annuler">Annuler</Button>
            <Button onClick={envoyer} disabled={envoi || !f.email} className="bg-emerald-700 hover:bg-emerald-800" data-testid="conciliation-envoi-ok">
              {envoi ? <Loader2 className="h-4 w-4 mr-1 animate-spin" /> : <Send className="h-4 w-4 mr-1" />}Envoyer
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
